
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETALLREFERRALSSECTIONSBYSECTIONNAMEBASEDONCREATOR
// GETALLREFERRALSSECTIONSBYSECTIONNAMEBASEDONCREATOR


const GETALLREFERRALSSECTIONSBYSECTIONNAMEBASEDONCREATOR= createAsyncThunk(
  "getAllReferralSectionsBySectionNameBasedOnCreator/getAllReferralSectionsBySectionNameBasedOnCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllReferralSectionsBySectionNameBasedOnCreatorSlice = createSlice({
  name: "getAllReferralSectionsBySectionNameBasedOnCreatorSlice",
  initialState: {
    getAllReferralSectionsBySectionNameBasedOnCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllReferralSectionsBySectionNameBasedOnCreator: (state) => {
        state.getAllReferralSectionsBySectionNameBasedOnCreator.loading = false
        state.getAllReferralSectionsBySectionNameBasedOnCreator.error = false
        state.getAllReferralSectionsBySectionNameBasedOnCreator.data = []
        state.getAllReferralSectionsBySectionNameBasedOnCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLREFERRALSSECTIONSBYSECTIONNAMEBASEDONCREATOR.fulfilled, (state, action) => {
      state.getAllReferralSectionsBySectionNameBasedOnCreator = {
        ...state.getAllReferralSectionsBySectionNameBasedOnCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREFERRALSSECTIONSBYSECTIONNAMEBASEDONCREATOR.pending, (state, action) => {
      state.getAllReferralSectionsBySectionNameBasedOnCreator = {
        ...state.getAllReferralSectionsBySectionNameBasedOnCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREFERRALSSECTIONSBYSECTIONNAMEBASEDONCREATOR.rejected, (state, action) => {
      state.getAllReferralSectionsBySectionNameBasedOnCreator = {
        ...state.getAllReferralSectionsBySectionNameBasedOnCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllReferralSectionsBySectionNameBasedOnCreatorAction = {
    GETALLREFERRALSSECTIONSBYSECTIONNAMEBASEDONCREATOR,
};

export { getAllReferralSectionsBySectionNameBasedOnCreatorAction };
export default getAllReferralSectionsBySectionNameBasedOnCreatorSlice.reducer;
export const {setInitialStateOfgetAllReferralSectionsBySectionNameBasedOnCreator} = getAllReferralSectionsBySectionNameBasedOnCreatorSlice.actions
